import { Controller } from 'stimulus'
import { roundNumber, formatNumber } from '../components/quotes/form/helpers'

export default class extends Controller {

  static targets = ['totalsPurchasePrice', 'totalsCoefficient', 'totalsUnitPrice']

  connect() {
    this.refreshTotals()
  }

  refreshTotals() {
    let totalPurchasePrice = 0
    let totalUnitPrice     = 0

    const breakdownRows = this.element.querySelectorAll('[data-controller~="qline-breakdown-blueprint"]')
    breakdownRows.forEach(row => {
      const quantityInput      = row.querySelector('input[name*="[quantity]"]')
      const purchasePriceInput = row.querySelector('[data-target~="qline-breakdown-blueprint.purchasePrice"]')
      const unitPriceInput     = row.querySelector('[data-target~="qline-breakdown-blueprint.unitPrice"]')

      if (!quantityInput || !purchasePriceInput || !unitPriceInput) return

      const quantity      = roundNumber(quantityInput.value)
      const purchasePrice = roundNumber(purchasePriceInput.value)
      const unitPrice     = roundNumber(unitPriceInput.value)

      totalPurchasePrice += quantity * purchasePrice
      totalUnitPrice     += quantity * unitPrice
    })

    this.totalsPurchasePriceTarget.value = formatNumber(totalPurchasePrice)
    this.totalsUnitPriceTarget.value     = formatNumber(totalUnitPrice)
    this.totalsCoefficientTarget.value   = totalPurchasePrice > 0 ? roundNumber(totalUnitPrice / totalPurchasePrice) : "-"
  }
}
